import script from "./DataTableColumnStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableColumnStatistics.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableColumnStatistics.vue?vue&type=style&index=0&id=2fe0867e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe0867e"]])

export default __exports__